import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductCategories, getAllProducts } from "../../../api/action/products.jsx";
import ScrollableFeaturedProducts from "../SunFlare-Theme/components/ScrollableFeaturedProducts.jsx";
import Carousel from "./components/Carousel.jsx";
import CategorySection from "./components/CategorySection.jsx";
import { academyLogger } from "utils/logger";

function SunFlareTemplate() {
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const companyPrimayId = useSelector((state) => state.companyReducer.company?.primaryId);
  const user = useSelector((state) => state?.auth?.data);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!companyPrimayId) {
        setCategoryProducts([]);
        return;
      }

      try {
        const response = await getAllProducts(companyPrimayId)(dispatch);
        setCategoryProducts(Array.isArray(response) ? response : []);
      } catch (error) {
        academyLogger.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, [companyPrimayId, dispatch]);

  useEffect(() => {
    const fetchCategories = async () => {
      if (!companyPrimayId) {
        setCategories([]);
        return;
      }

      try {
        const response = await getAllProductCategories(companyPrimayId)(dispatch);
        setCategories(Array.isArray(response) ? response : []);
      } catch (error) {
        academyLogger.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, [companyPrimayId, dispatch]);


  return (
    < >
      <Carousel />
      <CategorySection categories={categories} />
      <ScrollableFeaturedProducts
        productList={categoryProducts}
        loggedIn={!!user}
      />

    </ >
  );
}

export default SunFlareTemplate;
